// extracted by mini-css-extract-plugin
export default {"Separator":"SectionSeparator_Separator__LfBOf","blue":"SectionSeparator_blue__4pOd1","pink":"SectionSeparator_pink__LJou6"};